module.exports = require("@pb/kit-component-icon/dist/styles-chunk.css");